export default function SignUpPage(): React.ReactElement {
  return (
    <main style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>You need an invitation</h1>
        <p style={styles.body}>
          Ask your Scale Advisors contact for a personal invitation link. Public account creation is turned off.
        </p>
        <a href="/login" style={styles.link}>Already have an account? Sign in</a>
      </div>
    </main>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: { minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--surface-2)", color: "var(--text)", padding: 24 },
  card: { width: "min(460px, 100%)", boxSizing: "border-box", background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 12, padding: 32 },
  title: { margin: 0, fontSize: 26, lineHeight: 1.2 },
  body: { margin: "12px 0 20px", color: "var(--body)", fontSize: 15, lineHeight: 1.55 },
  link: { color: "var(--accent)", fontWeight: 700 },
};
